import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
    colors: {
        brand: {
            yellow: "#ffcd03",
        },
    },
    styles: {
        global: {
            body: {
                fontFamily: "Montserrat, sans-serif"
            },
        },
    },
    fonts: {
        body: 'Montserrat, sans-serif',
        heading: 'Montserrat, sans-serif',
    },
});

export default theme;